import { io } from 'socket.io-client';

//export const socket = io('http://192.168.100.251:4000');

export const socket = io('https://operatic.cetemin.edu.pe:8080');